import { updatePersistedState } from "orion-components/AppState/Actions";
import { createUserFeedback } from "orion-components/Dock/Actions/index.js";
import { entityCollection, eventService, integrationService } from "client-app-core";
import { closeSecondary } from "orion-components/ContextPanel/Actions";
import { clearSelectedEntity } from "orion-components/AppState/Actions";

export const updateActivityFilters = (appId, keyVal) => {
	return (dispatch) => {
		dispatch(updatePersistedState(appId, "activityFilters", keyVal));
	};
};

export const setWidgetOrder = (profile, widgets, autoExpand) => {
	return (dispatch, getState) => {
		const state = getState();
		const appId = state.application.appId;
		const profiles = { ...(state.appState?.persisted?.["profiles"] ?? {}) };

		// Ensure the nested properties exist
		createNestedPropertiesIfNotFound(profiles, `${profile}.widgetOrder`, widgets);
		createNestedPropertiesIfNotFound(profiles, `${profile}.layoutControls`, {});

		// Set the widget order and layout controls
		profiles[profile].widgetOrder = widgets;
		profiles[profile].layoutControls.autoExpand = autoExpand;

		// Dispatch the update action
		if (appId === "cameras-app") {
			dispatch(updatePersistedState("global", "profiles", profiles, false));
		} else {
			dispatch(updatePersistedState("global", "profiles", profiles));
		}
	};
};

export const addRemoveFromCollections = (entityId, added, removed, entityName, entityType, feedId, undoing) => {
	return (dispatch) => {
		const addedIds = added.map((collection) => collection.id);
		const removedIds = removed.map((collection) => collection.id);
		entityCollection.addRemoveMemberToMulti(
			entityId,
			entityName,
			entityType,
			feedId,
			addedIds,
			removedIds,
			(err, response) => {
				if (err) {
					console.log(err, response);
				} else {
					if (!undoing) {
						const undo = true;
						const undoFunc = () => {
							dispatch(
								// We pass null for entityName, entityType, and feedId to prevent activities
								// from generating when we undo a collection update
								addRemoveFromCollections(entityId, removed, added, null, null, null, undo)
							);
						};
						let addedMessage = "";
						let removedMessage = "";
						if (added[0]) {
							added.forEach((collection, index) => {
								addedMessage +=
									index !== added.length - 1 ? `${collection.name}, ` : `${collection.name}`;
							});
						}
						if (removed[0]) {
							removed.forEach((collection, index) => {
								removedMessage +=
									index !== removed.length - 1 ? `${collection.name}, ` : `${collection.name}`;
							});
						}
						let completeMessage = addedMessage ? entityName + " added to " + addedMessage + "." : "";
						completeMessage += removedMessage ? entityName + " removed from " + removedMessage + "." : "";
						dispatch(createUserFeedback(completeMessage, undoFunc));
					}
				}
			}
		);
	};
};

export const addRemoveFromEvents = (entityId, entityType, feedId, added, removed) => {
	return () => {
		eventService.updatePinnedEntities(entityId, entityType, feedId, added, removed, (err, response) => {
			if (err) {
				console.log(err, response);
			}
		});
	};
};

export const closeProfile = () => {
	return (dispatch) => {
		dispatch(closeSecondary());
		dispatch(clearSelectedEntity());
	};
};
export function createCollection(name, members) {
	return function (dispatch, getState) {
		const state = getState();
		entityCollection.createCollection(name, members, (err, response) => {
			if (err) {
				console.log(err);
			} else {
				if ((state.appId && state.appId === "events-app") || state.appId === "map-app") {
					const id = response.generated_keys[0];

					const undo = true;

					const undoFunc = () => {
						dispatch(deleteCollection(id, name, undo));
					};
					dispatch(createUserFeedback(name + " has been created.", undoFunc));
				}
			}
		});
	};
}

export function deleteCollection(collectionId, collectionName, undoing) {
	return function (dispatch) {
		entityCollection.deleteCollection(collectionId, (err, response) => {
			if (err) {
				console.log(err, response);
			} else {
				if (!undoing) {
					const undoFunc = () => {
						dispatch(restoreCollection(collectionId));
					};

					dispatch(createUserFeedback(collectionName + " has been deleted.", undoFunc));
				}
			}
		});
	};
}

export function restoreCollection(collectionId) {
	return function () {
		entityCollection.restoreCollection(collectionId, (err, response) => {
			if (err) {
				console.log(err);
			} else {
				console.log(response);
			}
		});
	};
}

export const setWidgetState = (widgetName, widgetState) => {
	return (dispatch) => {
		const keyVal = { [widgetName]: widgetState };
		dispatch(updatePersistedState("global", "widgets", keyVal));
	};
};

//CB2-7148: According to this JIRA requirement, the activityFilters that were common and shared among all entity profiles caused issues when an entity profile and an alert profile were opened simultaneously and changes were made to the activity filter. To address this issue, entity-specific activity filters have been designed below.
export const setEntityActivityFilters = (profile, filters) => {
	return (dispatch, getState) => {
		const state = getState();
		const profiles = { ...(state.appState?.persisted?.["profiles"] ?? {}) };
		// Ensure the nested properties exist
		createNestedPropertiesIfNotFound(profiles, `${profile}.widgets.activities.filters`, filters);
		// Set the filters
		profiles[profile].widgets.activities.filters = filters;
		const appId = "global";
		dispatch(updatePersistedState(appId, "profiles", profiles));
	};
};

const createNestedPropertiesIfNotFound = (obj, path, defaultValue) => {
	// Split the path into parts
	const parts = path.split(".");
	let current = obj;

	// Iterate through the parts of the path
	for (let i = 0; i < parts.length; i++) {
		const part = parts[i];
		// If the part does not exist, create it with the default value
		if (!current[part]) {
			current[part] = i === parts.length - 1 ? defaultValue : {};
		}
		current = current[part];
	}
};

export const verifyDetection = (externalSystemId, eventId, verification, alertId) => {
	const resourceType = `verification?eventId=${eventId}&verification=${verification}&alertId=${alertId}`;

	return () => {
		integrationService.postExternalSystemResource(externalSystemId, resourceType, null, (err, response) => {
			if (err) {
				console.log(err);
			} else {
				console.log(response);
			}
		})
	}
};